import { createContext, useContext } from 'react';

const NO_FIELDS: ReadonlySet<string> = new Set();

// Names of the form fields that are shown like a field with a validation
// error (light red background) without having one, e.g. the fields behind a
// red warning.
export const HighlightedFieldsContext =
  createContext<ReadonlySet<string>>(NO_FIELDS);

export function useIsFieldHighlighted(name: string) {
  return useContext(HighlightedFieldsContext).has(name);
}
